import { storage } from "@core/storage/storage";
import { IdentityStatus, PtStatus, RegistrationStatus } from "@domain/user/user";
import { isNotNil } from "@utils/assert";
import { observable } from "micro-observables";

export class UserStatusManager {
	private readonly _ptRegistrationStatus = observable<RegistrationStatus | null>(null);
	readonly ptRegistrationStatus = this._ptRegistrationStatus.readOnly();

	private readonly _hcpStatus = observable<PtStatus | null>(null);
	readonly hcpStatus = this._hcpStatus.readOnly();

	private readonly _identityStatus = observable<IdentityStatus | null>(null);
	readonly identityStatus = this._identityStatus.readOnly();

	private readonly _registrationStepStore = storage.getStore<string[], string[]>(
		"registrationIntroductionStep",
		v => v,
		v => v,
	);

	updatePtRegistrationStatus(newPtStatus: RegistrationStatus): void {
		this._ptRegistrationStatus.set(newPtStatus);
	}

	updateHcpStatus(newHcpStatus: PtStatus): void {
		this._hcpStatus.set(newHcpStatus);
	}

	updateIdentityStatus(newIdentityStatus: IdentityStatus): void {
		this._identityStatus.set(newIdentityStatus);
	}

	reset(): void {
		this._ptRegistrationStatus.set(null);
		this._hcpStatus.set(null);
		this._identityStatus.set(null);
	}

	updatePtViewedIntroduction(userId: string): void {
		if (isNotNil(userId))
			this._registrationStepStore.setItem({
				...this._registrationStepStore.getItem(),
				[userId]: true,
			});
	}

	hasPtViewedIntroduction(userId: string): boolean {
		const storeItems = this._registrationStepStore.getItem();
		return isNotNil(storeItems) && isNotNil(userId) && Object.keys(storeItems).includes(userId);
	}
}
